import { css } from "@emotion/react";

export const ulStyle = css`
  display: flex;
  justify-content: center;
`;

const smallStyle = css`
  font-size: 14px;
  line-height: 20px;
  padding-block: 4px;
`;

const mediumStyle = css`
  font-size: 16px;
  line-height: 24px;
  padding-block: 8px;
`;

const largeStyle = css`
  font-size: 18px;
  line-height: 28px;
  padding-block: 12px;
`;

export const sizeStyleMap = {
  large: largeStyle,
  medium: mediumStyle,
  small: smallStyle,
};

export const baseButtonStyle = css`
  background-color: #ffffff;
  border-radius: 26px;
  border: none;
  color: #000000;
  padding-inline: 16px;

  &[aria-selected="true"] {
    background-color: #000000;
    color: #ffffff;
    font-weight: 700;
  }

  &[aria-selected="false"] {
    cursor: pointer;
  }
`;
